import React, { Suspense } from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import AuthorisedLayout from "../layout/AuthorizedLayoutComponent";
import { Loader } from "../Shared/PageLoader";
import UomComponent from "../pages/Uom/UomComponent";
import OwnerShipTypeComponent from "../pages/OwnerShipType/OwnerShipTypeComponent";
import AssetStatusComponent from "../pages/AssetStatus/AssetStatusComponent";
import AssetLocationComponent from "../pages/AssetLocation/AssetLocationComponent";
import GroupComponent from "../pages/Group/GroupComponent";
import SubCategoryComponent from "../pages/SubCategory/SubCategoryComponent";
//import AssetSpecificationComponentOld from "../pages/AssetSpecification/AssetSpecificationComponentOld";
import PurchaseDetailComponent from "../pages/Purchase/PurchaseDetailComponent";
import ScrapComponent from "../pages/Purchase/ScrapComponent";
import AssetComponent from "../pages/Asset/AssetComponent";
import NewAssetComponent from "../pages/Asset/NewAssetComponent";
import AddAssetComponent from "../pages/Asset/AddAssetComponent";
import MaintComponent from "../pages/Maint/MaintComponent";
import { LoginPage } from "../LoginPage";
import { useSelector } from "react-redux";
import LazyLoad from "../../LazyLoad";
import CategoryComponent from "../pages/Category/CategoryComponent";
import Dashboard from "../layout/Dashboard";
// import {
//   useIsAllowedAllPermissionsForSomeRoles,
//   useGetCodeWiseAppModuleFeaturePermission,
// } from "../../helper/sessionHelper";
import AssetRequestComponent from "../pages/Request/AssetRequestComponent";
import AddAssetRequestComponent from "../pages/Request/AddAssetRequestComponent";
import {
  useIsAllowedAllPermissionsForSomeRoles,
  useGetCodeWiseAppModuleFeaturePermission,
} from "../../helper/sessionHelper";
import AssetIdNumberComponent from "../pages/Settings/AssetIdNumberComponent";
import AssetAttachmentAlertComponent from "../pages/Alert/AssetAttachmentAlertComponent";
import ApprovedAssetRequestComponent from "../pages/Request/ApprovedAssetRequestComponent";
import AssetMovementComponent from "../pages/Request/AssetMovementComponent";
import AssetPurchaseRequestComponent from "../pages/Request/AssetPurchaseRequestComponent";
import ViewAssetComponent from "../pages/Asset/ViewAssetComponent";
import AddAssetMovementComponent from "../pages/Request/AddAssetMovementComponent";
import AssetSpecificationComponent from "../pages/AssetSpecification/AssetSpecificationComponent";
import ViewAssetMovementComponent from "../pages/Request/ViewAssetMovementComponent";
import ReportAssetMovementComponent from "../pages/reports/ReportAssetMovementComponent";
import AssetScrapRequestComponent from "../pages/AssetScrapRequest/AssetScrapRequestComponent";
import SaveAssetScrapRequestComponent from "../pages/AssetScrapRequest/SaveAssetScrapRequestComponent";
import MyTaskComponent from "../pages/MyTasks/MyTaskComponent";
import ViewAssetScrapRequestComponent from "../pages/AssetScrapRequest/ViewAssetScrapRequestComponent";
import WorkFlowCategoryComponent from "../pages/Category/WorkFlowCategoryComponent";
import RequestForAssetPurchaseComponent from "../pages/Request/RequestForAssetPurchaseComponent";
import RequestForAssetHireComponent from "../pages/Request/RequestForAssetHireComponent";
import AddAssetQuotationComponent from "../pages/Request/AddAssetQuotationComponent";
import ViewAssetPurchaseQuotationComponent from "../pages/Request/ViewAssetPurchaseQuotationComponent";
import AssetDispatchComponent from "../pages/AssetDispatch/AssetDispatchComponent";
import AssetAcknowledgeComponent from "../pages/AssetAcknowledge/AssetAcknowledgeComponent";
import ReportAssetRequestComponent from "../pages/reports/ReportAssetRequestComponent";
import ReportAssetDispatchComponent from "../pages/reports/ReportAssetDispatchComponent";
import ReportAssetScrapComponent from "../pages/reports/ReportAssetScrapComponent";
import ReportAssetAcknowledgementComponent from "../pages/reports/ReportAssetAcknowledgementComponent";
import ReportAssetPurchaseComponent from "../pages/reports/ReportAssetPurchaseComponent";
import ReportAssetHireComponent from "../pages/reports/ReportAssetHireComponent";
import ImportPRComponent from "../pages/Request/ImportPRComponent";
import AssetMaterialMovementRequestComponent from "../pages/AssetMaterialMovementRequest/AssetMaterialMovementRequestComponent";
import SaveAssetMaterialMovementRequestComponent from "../pages/AssetMaterialMovementRequest/SaveAssetMaterialMovementRequestComponent";
import ViewAssetMaterialMovementRequestComponent from "../pages/AssetMaterialMovementRequest/ViewAssetMaterialMovementRequestComponent";
import MaterialMovementOrderComponent from "../pages/MaterialMovementOrder/MaterialMovementOrderComponent";
import ViewMaterialMovementOrderComponent from "../pages/MaterialMovementOrder/ViewMaterialMovementOrderComponent";
import UpdateMaterialMovementOrderComponent from "../pages/MaterialMovementOrder/UpdateMaterialMovementOrderComponent";
import PendingAssetRequestComponent from "../pages/Request/PendingAssetRequestComponent";
import AddAssetHireComponent from "../pages/Request/AddAssetHireComponent";
import ViewAssetHireQuotationComponent from "../pages/Request/ViewAssetHireQuotationComponent";
import ReportAssetMaterialMovementRequestComponent from "../pages/reports/ReportAssetMaterialMovementRequestComponent";
import ReportAssetMateiralMovementOrderComponent from "../pages/reports/ReportAssetMateiralMovementOrderComponent";

const DashboardComponent = LazyLoad(
  "./components/dashboard/DashboardComponent"
);

function AppRoutes() {
  const user = useSelector((state) => state.user.data);
  const isAuthorized = user?.authorized === true;

  const ProtectedRoute = ({ featureCode, permissionTypes, element }) => {
    let accessKeys = {
      view: "canView",
      add: "canAdd",
      edit: "canEdit",
      delete: "canDelete",
      export: "canExport",
      approve: "canApprove",
      reject: "canReject",
    };

    const isAllowedForThisRole = useIsAllowedAllPermissionsForSomeRoles();
    const featurePermission =
      useGetCodeWiseAppModuleFeaturePermission(featureCode); // here featureCode is actually applicationModuleFeature.code
    let isPermitted =
      permissionTypes === true
        ? true
        : permissionTypes?.some(
            (item) => featurePermission?.[accessKeys?.[item]]
          );

    return isAllowedForThisRole || isPermitted ? (
      React.cloneElement(element, { isAllowedForThisRole, featurePermission })
    ) : (
      <div>You do not have access to this page.</div>
    );
  };

  return (
    <>
      {isAuthorized === true ? (
        <AuthorisedLayout>
          <Routes>
            <Route path="/" element={<AuthorizedRouteWrapper />}>
              <Route
                path="*"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_ASSET"}
                    permissionTypes={["view"]}
                    element={<Navigate to="/Asset" replace />}
                    // element={<AssetComponent />}
                  />
                  // <ProtectedRoute
                  //   featureCode={"064e751e-7c70-48cf-9442-9a50d55d899c"}
                  //   permissionTypes={["view"]}
                  //   element={<AssetComponent />}
                  // />
                }
              />

              <Route
                path="/"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_ASSET"}
                    permissionTypes={["view"]}
                    element={<AssetComponent />}
                  />
                }
              />

              <Route
                path="/NewAsset"
                element={
                  <ProtectedRoute
                    featureCode={"3e44801f-5eac-4f46-b59d-ca59f4ac8a58"}
                    permissionTypes={["view"]}
                    element={<NewAssetComponent />}
                  />
                }
              />

              <Route
                path="/Asset"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_ASSET"}
                    permissionTypes={["view"]}
                    element={<AssetComponent />}
                  />
                }
              />

              <Route
                path="/Dashboard"
                element={
                  <ProtectedRoute
                    featureCode={"61310edc-0de6-41b0-ad18-0310b8fb0eed"}
                    permissionTypes={["view"]}
                    element={<Dashboard />}
                  />
                }
              />
              <Route path="/Uom" element={<UomComponent />} />
              <Route
                path="/OwnerShipType"
                element={
                  <ProtectedRoute
                    featureCode={"AM_MAS_OWNERSHIPTYPE"}
                    permissionTypes={["view"]}
                    element={<OwnerShipTypeComponent />}
                  />
                }
              />
              <Route
                path="/AssetStatus"
                element={
                  <ProtectedRoute
                    featureCode={"AM_MAS_STATUSTYPE"}
                    permissionTypes={["view"]}
                    element={<AssetStatusComponent />}
                  />
                }
              />
              <Route
                path="/AssetLocation"
                element={
                  <ProtectedRoute
                    featureCode={"AM_MAS_LOCATION"}
                    permissionTypes={["view"]}
                    element={<AssetLocationComponent />}
                  />
                }
              />
              <Route
                path="/Group"
                element={
                  <ProtectedRoute
                    featureCode={"AM_MAS_ASSETGROUP"}
                    permissionTypes={["view"]}
                    element={<GroupComponent />}
                  />
                }
              />
              <Route
                path="/Category"
                element={
                  <ProtectedRoute
                    featureCode={"984f2426-7ef8-4756-ad3e-3c7e9327ac6f"}
                    permissionTypes={["view"]}
                    element={<CategoryComponent />}
                  />
                }
              />
              <Route
                path="/SubCategory"
                element={
                  <ProtectedRoute
                    featureCode={"83dd9516-3e62-4952-9aea-22179902a0c6"}
                    permissionTypes={["view"]}
                    element={<SubCategoryComponent />}
                  />
                }
              />
              <Route
                path="/Specification"
                element={
                  <ProtectedRoute
                    featureCode={"AM_MAS_ASSETSPEC"}
                    permissionTypes={["view"]}
                    element={<AssetSpecificationComponent />}
                  />
                }
              />
              <Route path="/Purcahse" element={<PurchaseDetailComponent />} />
              <Route
                path="/Scrap"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_SCRAP"}
                    permissionTypes={["view"]}
                    element={<ScrapComponent />}
                  />
                }
              />
              <Route
                path="/AddAsset"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_ASSET"}
                    permissionTypes={["add", "edit"]}
                    element={<AddAssetComponent />}
                  />
                }
              />
              <Route
                path="/asset-preview"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_ASSET_PREVIEW"}
                    permissionTypes={true}
                    element={<ViewAssetComponent />}
                  />
                }
              />
              <Route
                path="/Maint"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_MAINTENANCE"}
                    permissionTypes={["view"]}
                    element={<MaintComponent />}
                  />
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute
                    featureCode={"61310edc-0de6-41b0-ad18-0310b8fb0eed"}
                    permissionTypes={["view"]}
                    element={<Dashboard />}
                  />
                }
              />
              {/* <Route path="/assetRequest" element={<AssetRequestComponent />} /> */}
              <Route
                path="/AddAssetRequest"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_AssetReq"}
                    permissionTypes={["view"]}
                    element={<AddAssetRequestComponent />}
                  />
                }
              />

              <Route
                path="/ApprovedAssetRequest"
                element={
                  <ProtectedRoute
                    featureCode={"61f04c61-3c68-415e-ba46-5fc1a05cc4f8"}
                    permissionTypes={["view"]}
                    element={<ApprovedAssetRequestComponent />}
                  />
                }
              />

              <Route
                path="/AssetMovement"
                element={
                  <ProtectedRoute
                    featureCode={"69186ae7-409c-4f66-82bb-fb1344441005"}
                    permissionTypes={["view"]}
                    element={<AssetMovementComponent />}
                  />
                }
              />

              <Route
                path="/PendingPRSAP"
                element={
                  <ProtectedRoute
                    featureCode={"aa871b01-c5dd-4126-9f65-381868cee73a"}
                    permissionTypes={["view"]}
                    element={<AssetPurchaseRequestComponent />}
                  />
                }
              />

              <Route
                path="/Scrap"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_SCRAP"}
                    permissionTypes={["view"]}
                    element={<ScrapComponent />}
                  />
                }
              />
              <Route
                path="/Asset"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_ASSET"}
                    permissionTypes={["view"]}
                    element={<AssetComponent />}
                  />
                }
              />
              <Route
                path="/AddAsset"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_ASSET"}
                    permissionTypes={["add", "edit"]}
                    element={<AddAssetComponent />}
                  />
                }
              />
              <Route
                path="/Maint"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_MAINTENANCE"}
                    permissionTypes={["view"]}
                    element={<MaintComponent />}
                  />
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute
                    featureCode={"61310edc-0de6-41b0-ad18-0310b8fb0eed"}
                    permissionTypes={["view"]}
                    element={<Dashboard />}
                  />
                }
              />
              <Route
                path="/AssetRequest"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_AssetReq"}
                    permissionTypes={["view"]}
                    element={<AssetRequestComponent />}
                  />
                }
              />
              <Route
                path="/assetAttachment"
                element={<AssetAttachmentAlertComponent />}
              />
              <Route path="/viewAsset" element={<ViewAssetComponent />} />
              <Route
                path="/addAssetMovement"
                element={
                  <ProtectedRoute
                    featureCode={"69186ae7-409c-4f66-82bb-fb1344441005"}
                    permissionTypes={["view"]}
                    element={<AddAssetMovementComponent />}
                  />
                }
              />
              <Route
                path="/asset-movement-preview"
                element={
                  <ProtectedRoute
                    featureCode={"69186ae7-409c-4f66-82bb-fb1344441005"}
                    permissionTypes={true}
                    element={<ViewAssetMovementComponent />}
                  />
                }
              />
              <Route
                path="/ReportAssetMovement"
                element={
                  <ProtectedRoute
                    featureCode={"RPT_ASSET_MOVEMENT"}
                    permissionTypes={["view"]}
                    element={<ReportAssetMovementComponent />}
                  />
                }
              />
              <Route
                path="/WorkFlowCategory"
                element={
                  <ProtectedRoute
                    featureCode={"AS_WORKFLOW_CATEGORY"}
                    permissionTypes={true}
                    element={<WorkFlowCategoryComponent />}
                  />
                }
              />
              <Route
                path="/AssetScrap"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_SCRAP"}
                    permissionTypes={["view"]}
                    element={<AssetScrapRequestComponent />}
                  />
                }
              />
              <Route
                path="/SaveAssetScrapRequest"
                element={
                  <ProtectedRoute
                    featureCode={"AM_A&L_SCRAP"}
                    permissionTypes={["view"]}
                    element={<SaveAssetScrapRequestComponent />}
                  />
                }
              />
              <Route
                path="/MyTasks"
                element={
                  <ProtectedRoute
                    featureCode={"b0cbca53-4fc7-4a85-ab49-2a7f771219ef"}
                    permissionTypes={true}
                    element={<MyTaskComponent />}
                  />
                }
              />
              <Route
                path="/ViewAssetScrapRequest"
                element={<ViewAssetScrapRequestComponent />}
              />
              <Route
                path="/RequestAssetPurchase"
                element={
                  <ProtectedRoute
                    featureCode={"31c9e394-9cab-4e47-85d3-a3824e70d1e5"}
                    permissionTypes={["view"]}
                    element={<RequestForAssetPurchaseComponent />}
                  />
                }
              />
              <Route
                path="/addAssetQuotation"
                element={
                  <ProtectedRoute
                    featureCode={"31c9e394-9cab-4e47-85d3-a3824e70d1e5"}
                    permissionTypes={["view"]}
                    element={<AddAssetQuotationComponent />}
                  />
                }
              />
              <Route
                path="/asset-purchase-preview"
                element={
                  <ProtectedRoute
                    featureCode={"31c9e394-9cab-4e47-85d3-a3824e70d1e5"}
                    permissionTypes={true}
                    element={<ViewAssetPurchaseQuotationComponent />}
                  />
                }
              />
              <Route
                path="/RequestAssetHire"
                element={
                  <ProtectedRoute
                    featureCode={"aea33f40-5e4c-4af9-8992-213ab1f32608"}
                    permissionTypes={["view"]}
                    element={<RequestForAssetHireComponent />}
                  />
                }
              />
              <Route
                path="/addAssetHire"
                element={
                  <ProtectedRoute
                    featureCode={"aea33f40-5e4c-4af9-8992-213ab1f32608"}
                    permissionTypes={["view"]}
                    element={<AddAssetHireComponent />}
                  />
                }
              />
              <Route
                path="/asset-hire-preview"
                element={
                  <ProtectedRoute
                    featureCode={"aea33f40-5e4c-4af9-8992-213ab1f32608"}
                    permissionTypes={true}
                    element={<ViewAssetHireQuotationComponent />}
                  />
                }
              />
            </Route>
            <Route
              path="/assetDispatch"
              element={
                <ProtectedRoute
                  featureCode={"AM_A&L_DISPATCH"}
                  permissionTypes={true}
                  element={<AssetDispatchComponent />}
                />
              }
            />
            <Route
              path="/assetAcknowledge"
              element={
                <ProtectedRoute
                  featureCode={"AM_ACKNOWLEDGE"}
                  permissionTypes={true}
                  element={<AssetAcknowledgeComponent />}
                />
              }
            />
            <Route
              path="/ReportAssetRequest"
              element={
                <ProtectedRoute
                  featureCode={"RPT_ASSET_REQUEST"}
                  permissionTypes={["view"]}
                  element={<ReportAssetRequestComponent />}
                />
              }
            />
            <Route
              path="/ReportAssetScrap"
              element={
                <ProtectedRoute
                  featureCode={"RPT_ASSET_SCRAP"}
                  permissionTypes={["view"]}
                  element={<ReportAssetScrapComponent />}
                />
              }
            />
            <Route
              path="/ReportAssetDispatch"
              element={
                <ProtectedRoute
                  featureCode={"RPT_ASSET_DISPATCH"}
                  permissionTypes={["view"]}
                  element={<ReportAssetDispatchComponent />}
                />
              }
            />
            <Route
              path="/ReportAssetAcknowledgement"
              element={
                <ProtectedRoute
                  featureCode={"RPT_ASSET_ACKNOWLEDGEMENT"}
                  permissionTypes={["view"]}
                  element={<ReportAssetAcknowledgementComponent />}
                />
              }
            />
            <Route
              path="/ReportAssetPurchase"
              element={
                <ProtectedRoute
                  featureCode={"RPT_ASSET_PURCHASE"}
                  permissionTypes={["view"]}
                  element={<ReportAssetPurchaseComponent />}
                />
              }
            />
            <Route
              path="/ReportAssetHire"
              element={
                <ProtectedRoute
                  featureCode={"RPT_ASSET_HIRE"}
                  permissionTypes={["view"]}
                  element={<ReportAssetHireComponent />}
                />
              }
            />
            <Route
              path="/ImportPR"
              element={
                <ProtectedRoute
                  featureCode={"IMPORT_PR"}
                  permissionTypes={["view"]}
                  element={<ImportPRComponent />}
                />
              }
            />
            <Route
              path="/MaterialMovementRequest"
              element={
                <ProtectedRoute
                  featureCode={"MATERIAL_MMR"}
                  permissionTypes={["view"]}
                  element={<AssetMaterialMovementRequestComponent />}
                />
              }
            />
            <Route
              path="/SaveMaterialMovementRequest"
              element={
                <ProtectedRoute
                  featureCode={"MATERIAL_MMR"}
                  permissionTypes={true}
                  element={<SaveAssetMaterialMovementRequestComponent />}
                />
              }
            />
            <Route
              path="/ViewMaterialMovementRequest"
              element={
                <ProtectedRoute
                  featureCode={"MATERIAL_MMR"}
                  permissionTypes={true}
                  element={<ViewAssetMaterialMovementRequestComponent />}
                />
              }
            />
            <Route
              path="/MaterialMovementOrder"
              element={
                <ProtectedRoute
                  featureCode={"MaterialMovementOrder"}
                  permissionTypes={["view"]}
                  element={<MaterialMovementOrderComponent />}
                />
              }
            />
            <Route
              path="/material-movement-order-preview"
              element={
                <ProtectedRoute
                  featureCode={"MM_M&L_ORDER_PREVIEW"}
                  permissionTypes={true}
                  element={<ViewMaterialMovementOrderComponent />}
                />
              }
            />
            <Route
              path="/UpdateMaterialMovementOrder"
              element={
                <ProtectedRoute
                  featureCode={"MaterialMovementOrder"}
                  permissionTypes={true}
                  element={<UpdateMaterialMovementOrderComponent />}
                />
              }
            />
            <Route
              path="/PendingAssetRequest"
              element={
                <ProtectedRoute
                  featureCode={"PENDING_AR"}
                  permissionTypes={true}
                  element={<PendingAssetRequestComponent />}
                />
              }
            />
            <Route
              path="/ReportMaterialMovementRequest"
              element={
                <ProtectedRoute
                  featureCode={"RPT_MATERIAL_REQUEST"}
                  permissionTypes={["view"]}
                  element={<ReportAssetMaterialMovementRequestComponent />}
                />
              }
            />
            <Route
              path="/ReportMaterialMovementOrderRequest"
              element={
                <ProtectedRoute
                  featureCode={"RPT_MATERIAL_MOVEMENT_ORDER"}
                  permissionTypes={["view"]}
                  element={<ReportAssetMateiralMovementOrderComponent />}
                />
              }
            />
          </Routes>
        </AuthorisedLayout>
      ) : (
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="*" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
          </Routes>
        </Suspense>
      )}
    </>
  );
}
export default AppRoutes;

function AuthorizedRouteWrapper() {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </>
  );
}
